import PropTypes from 'prop-types';

import { styled } from '@mui/material/styles';
import { AppBar, Toolbar, IconButton, Grid } from '@mui/material';

import { bgBlur } from '../../../utils/cssStyles';

import Iconify from '../../../components/iconify';

import LanguagePopover from './LanguagePopover';

import AccountPopover from './AccountPopover';



const NAV_WIDTH = 300;
const HEADER_MOBILE = 60;
const HEADER_DESKTOP = 90;

const StyledRoot = styled(AppBar)(({ theme }) => ({
  ...bgBlur({ color: theme.palette.background.default }),
  boxShadow: 'none',
  height: `${HEADER_MOBILE}px`,
  ...(theme.breakpoints.up('lg') && {
    height: `${HEADER_DESKTOP}px`,
    width: `calc(100% - ${NAV_WIDTH + 1}px)`,
  }),
  backgroundColor: 'transparent', 
  '&:hover': {
    backgroundColor: 'transparent',
  },
}));

const StyledToolbar = styled(Toolbar)(({ theme }) => ({
  minHeight: HEADER_MOBILE,
  [theme.breakpoints.up('lg')]: {
    minHeight: HEADER_DESKTOP,
    padding: theme.spacing(0, 5),
  },
}));



Header.propTypes = {
  onOpenNav: PropTypes.func,
};

export default function Header({ onOpenNav }) {
  return (
    <StyledRoot>
      <StyledToolbar>
        <IconButton
          onClick={onOpenNav}
          sx={{
            mr: 1,
            color: 'text.primary',
            display: { sm: 'none' },
          }}
        >
          <Iconify icon="eva:menu-2-fill" />
        </IconButton>

        <Grid container direction={'row'} style={{ placeContent: 'space-between' }}>
          <Grid item>
            <LanguagePopover />
          </Grid>
          <Grid item>
            {' '}
            {}
          </Grid>
          <Grid item>
            {' '}
            <AccountPopover />
          </Grid>
        </Grid>
      </StyledToolbar>
    </StyledRoot>
  );
}
